import React, { useCallback, useState } from "react";
import { MyDriversContext } from "../context";
import { ListCompanyType } from "../models";
import { useIoCContext } from "@context/IoCContext/IoCContext";
import { IMyDriversService } from "@modules/user/models/IMyDriversService";
import { Types } from "@ioc/types";
import AppError from "@utils/AppError";
import { DriversResponse } from "@pages/User/MyDrivers/models";
import useDialogAlert from "@hooks/useDialogAlert";

export const MyDriversProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [page, setPage] = useState<number>(0);
  const [filters, setFilters] = useState({
    driverQuery: "",
    companyDocuments: "",
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [listCompany, setListCompany] = useState<ListCompanyType>({
    companyDocuments: [],
  });
  const [data, setData] = useState<DriversResponse>({
    count: null,
    rows: [],
  } as DriversResponse);

  const { serviceContainer } = useIoCContext();
  const { snackbar } = useDialogAlert();

  const myDriversService = serviceContainer.get<IMyDriversService>(
    Types.Users.IMyDriverService
  );

  const fetchAllDrivers = useCallback(async () => {
    try {
      setLoading(true);

      const { driverQuery, companyDocuments } = filters;
      const response = await myDriversService.getAllDrivers(
        page + 1,
        driverQuery,
        companyDocuments
      );

      setData(response);
    } catch (error) {
      if (error instanceof AppError) {
        snackbar({
          message: `Não foi possível buscar os motoristas: ${error.message}`,
          variant: "error",
          autoHideDuration: 3000,
        });
      }
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, filters]);

  return (
    <MyDriversContext.Provider
      value={{
        listCompany,
        page,
        data,
        loading,
        filters,
        setFilters,
        setLoading,
        setData,
        setPage,
        setListCompany,
        fetchAllDrivers,
      }}
    >
      {children}
    </MyDriversContext.Provider>
  );
};
